var _defs, _path, _path2, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    "data-name": "24x24/On Light/Google",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.791 7.364H9.209v3.477h4.94c-.46 2.209-2.386 3.477-4.94 3.477A5.37 5.37 0 013.767 9 5.442 5.442 0 0112.6 4.868l2.679-2.618A9.29 9.29 0 009.209 0 9.08 9.08 0 000 9a9.08 9.08 0 009.209 9A8.586 8.586 0 0018 9a7.306 7.306 0 00-.209-1.636z",
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "a",
    d: "M20.791 10.364h-8.582v3.477h4.94c-.46 2.209-2.386 3.477-4.94 3.477A5.37 5.37 0 016.767 12 5.442 5.442 0 0115.6 7.868l2.679-2.618A9.29 9.29 0 0012.209 3 9.08 9.08 0 003 12a9.08 9.08 0 009.209 9A8.586 8.586 0 0021 12a7.306 7.306 0 00-.209-1.636z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Clipped",
    clipPath: "url(#a)",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.837 14.318V3.682L6.279 9z",
    fill: "#fbbc05"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Clipped"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "a",
    d: "M20.791 10.364h-8.582v3.477h4.94c-.46 2.209-2.386 3.477-4.94 3.477A5.37 5.37 0 016.767 12 5.442 5.442 0 0115.6 7.868l2.679-2.618A9.29 9.29 0 0012.209 3 9.08 9.08 0 003 12a9.08 9.08 0 009.209 9A8.586 8.586 0 0021 12a7.306 7.306 0 00-.209-1.636z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Clipped",
    clipPath: "url(#a)",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M-.837 3.682L6.279 9l2.93-2.5 10.047-1.6V-.818H-.837z",
    fill: "#ea4335"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Clipped"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "a",
    d: "M20.791 10.364h-8.582v3.477h4.94c-.46 2.209-2.386 3.477-4.94 3.477A5.37 5.37 0 016.767 12 5.442 5.442 0 0115.6 7.868l2.679-2.618A9.29 9.29 0 0012.209 3 9.08 9.08 0 003 12a9.08 9.08 0 009.209 9A8.586 8.586 0 0021 12a7.306 7.306 0 00-.209-1.636z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Clipped",
    clipPath: "url(#a)",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M-.837 14.318l12.558-9.409 3.307.409 4.228-6.136v19.636H-.837z",
    fill: "#34a853"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Clipped"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "a",
    d: "M20.791 10.364h-8.582v3.477h4.94c-.46 2.209-2.386 3.477-4.94 3.477A5.37 5.37 0 016.767 12 5.442 5.442 0 0115.6 7.868l2.679-2.618A9.29 9.29 0 0012.209 3 9.08 9.08 0 003 12a9.08 9.08 0 009.209 9A8.586 8.586 0 0021 12a7.306 7.306 0 00-.209-1.636z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Clipped",
    clipPath: "url(#a)",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M19.256 18.818L6.279 9 4.605 7.773l14.651-4.091z",
    fill: "#4285f4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.68358c56fc5c6c832659df1a5cc4d990.svg";
export { ForwardRef as ReactComponent };